import { useEffect, useState } from "react";

const NAV = [
  { label: "Leistungen", href: "#leistungen" },
  { label: "Prozess", href: "#process" },
  { label: "Kontakt", href: "#contact" },
];

export default function Header() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      // Header komplett ausblenden ab 80px, sanftes Fade-Out ohne BG-Flash.
      // Kommt zurück sobald der User wieder ganz nach oben scrollt.
      setHidden(y > 80);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        hidden ? "pointer-events-none" : "pointer-events-auto"
      }`}
      style={{
        backgroundColor: "transparent",
        WebkitMaskImage:
          "linear-gradient(to bottom, black 0%, black 60%, rgba(0,0,0,0.85) 80%, rgba(0,0,0,0.4) 92%, transparent 100%)",
        maskImage:
          "linear-gradient(to bottom, black 0%, black 60%, rgba(0,0,0,0.85) 80%, rgba(0,0,0,0.4) 92%, transparent 100%)",
        paddingBottom: "14px",
        opacity: hidden ? 0 : 1,
        transform: hidden ? "translateY(-12px)" : "translateY(0)",
        transitionDuration: "300ms",
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12 h-24 lg:h-20 flex items-center justify-between">
        <a
          data-testid="header-logo"
          href="#top"
          className="flex items-center gap-3"
          aria-label="CRE8 Studio GmbH"
        >
          <img
            src="/media/cre8-logo.png"
            alt="CRE8 Studio GmbH Logo"
            width="192"
            height="48"
            fetchpriority="high"
            decoding="async"
            className="h-11 lg:h-12 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="relative text-sm font-medium text-bone/70 hover:text-signal transition-colors duration-300 group py-2"
            >
              {item.label}
              <span
                aria-hidden
                className="absolute left-0 -bottom-0.5 h-px w-full origin-left scale-x-0 bg-signal transition-transform duration-500 ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-x-100"
              />
            </a>
          ))}
        </nav>

        <a
          data-testid="header-cta"
          href="#contact"
          className="hidden lg:inline-flex items-center gap-2 px-5 py-2.5 bg-bone text-ink text-sm font-semibold hover:bg-signal hover:text-bone transition-colors duration-300"
        >
          Projekt starten
        </a>
      </div>
    </header>
  );
}
